import { Icon } from '@components';

import theme from '../../../../themes/colors';

const KycPendingBannerContent = () => (
  <div className="flex w-full justify-start gap-2 rounded-xl bg-cofeeYellow1 p-4 pb-6">
    <Icon
      name="alert-circle"
      stroke={theme.cofeeYellow8}
      className="mt-1 !size-5 text-cofeeYellow6"
    />
    <div className="flex cursor-default flex-col gap-1">
      <div className="text-lg font-semibold text-cofeeNeutral10">
        Action Required: KYC Update🚨!
      </div>
      <div className="text-base text-cofeeNeutral8">
        As per the revised RBI guidelines, kindly ensure that your KYC details
        are updated on or before{' '}
        <span className="font-bold">30th January 2026</span>.
        <br />
        For any assistance, please contact your respective account manager or
        sales representative.
      </div>
    </div>
  </div>
);

export default KycPendingBannerContent;
